import { Box, Stack } from "@mui/material";
import { DataGrid, GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import ScenarioConfigContext from "Context/ScenarioConfigContext";
import { useContext, useEffect, useState } from "react";
import UserContext from "../../../../Context/UserProvider";
import ErrorPage from "../../../../pages/ErrorPage/ErrorPage";
import TableSkelton from "../../../common/SkeltonComponent/TableSkelton";
import { useApiService } from "../../../../services/ApiService/ApiService";
import toast from 'react-hot-toast';

function checking_null_undefined(array: any) {
  if (array === null || array === undefined) {
    return [];
  }
  return array;
}

function difference(a1: any, a2: any) {
  var result = [];
  for (var i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

const columns: GridColDef[] = [
  {
    field: "combinedRange",
    headerName: "Combined Range",
    sortable: false,
    align: "center",
    headerAlign: "center",
    width: 150,
  },
  {
    field: "description",
    headerName: "Description",
    sortable: false,
    align: "left",
    headerAlign: "center",
    width: 520,
  },
  {
    field: "maxDCInputKW",
    headerName: "Max Rapid Charge Input",
    sortable: false,
    headerAlign: "center",
    align: "center",
    width: 200,
  },
  {
    field: "maxHomePowerInput",
    headerName: "Max Home power Input ",
    sortable: false,
    align: "center",
    headerAlign: "center",
    width: 200,
  },
  {
    field: "maxThreePhaseInput",
    headerName: "Max Three Phase Input ",
    sortable: false,
    align: "center",
    headerAlign: "center",
    width: 200,
  }
];

function ComparisonElectricVehicleTabScreen(props: any) {
  const {userInfo, setUserInfo} = useContext(UserContext);
  const [scenarioConfigInfo, setScenarioConfigInfo] = useContext(ScenarioConfigContext) as any;
  const fleetScenarioUuid = scenarioConfigInfo.draftScenario?.uuid;
  const [loading, setLoading] = useState(true);
  const [electricVehicles, setElectricVehicles] = useState([]) as any;
  const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>([]) as any;
  const [selectedRow, setSelectedRow] = useState([]) as any;
  const [isError, setIsError] = useState(false);
  const { fetchWithAuth } = useApiService();
  
  async function fetchEvList() {
    try {
      const response = await fetchWithAuth('/DragDrop/fleet/scenario/electric-vehicles/list', {
        method: 'POST',
        body: JSON.stringify({
          uuid: userInfo.uuid,
          fleetUuid: userInfo.fleetUuid,
          fleetScenarioUuid: fleetScenarioUuid
        })
      });

      if (!response.ok) {
        setIsError(true);
        return;
      }

      const res_json = await response.json();
      const electricVehicleList = checking_null_undefined(res_json.electricVehicleList || []);
      
      const electricVehicles = checking_null_undefined(
        electricVehicleList.map((e: any) => ({
          ...e.electricVehicle,
          maxThreePhaseInput: e.electricVehicle.maxThreePhaseInput.toLocaleString() + " kW",
          maxHomePowerInput: e.electricVehicle.maxHomePowerInput.toLocaleString() + " kW",
          maxDCInputKW: e.electricVehicle.maxDCInputKW.toLocaleString() + " kW",
          combinedRange: Math.round(e.electricVehicle.combinedRange).toLocaleString() + " " + userInfo.userProfile.distanceUnitShortDisplayName,
          id: e.fleetSnapshotElectricVehicleUuid,
          selected: e.selected,
        }))
      );
      const selectedRow = electricVehicles.filter((e: any) => e.selected);
      await setSelectionModel(selectedRow.map((r: any) => r.id));
      setSelectedRow(selectedRow);
      await setElectricVehicles(electricVehicles);
    } catch (error) {
      console.error('Error fetching EV list:', error);
      setIsError(true);
      toast.error('Failed to fetch electric vehicles');
    } finally {
      setLoading(false);
    }
  }

  async function toggleEv(EvId: any) {
    try {
      const response = await fetchWithAuth('/DragDrop/fleet/scenario/electric-vehicles/toggle', {
        method: 'POST',
        body: JSON.stringify({
          uuid: userInfo.uuid,
          fleetUuid: userInfo.fleetUuid,
          fleetScenarioElectricVehicleUuid: EvId
        })
      });

      if (!response.ok) {
        setIsError(true);
        toast.error('Failed to toggle electric vehicle');
        return;
      }
    } catch (error) {
      console.error('Error toggling EV:', error);
      setIsError(true);
      toast.error('Failed to toggle electric vehicle');
    }
  }

  async function toggleAll(selected: boolean) {
    try {
      const response = await fetchWithAuth('/DragDrop/fleet/scenario/electric-vehicles/toggle/all', {
        method: 'POST',
        body: JSON.stringify({
          uuid: userInfo.uuid,
          fleetUuid: userInfo.fleetUuid,
          allSelected: selected,
          fleetScenarioUuid: fleetScenarioUuid
        })
      });

      if (!response.ok) {
        setIsError(true);
        toast.error('Failed to toggle all electric vehicles');
        return;
      }
    } catch (error) {
      console.error('Error toggling all EVs:', error);
      setIsError(true);
      toast.error('Failed to toggle all electric vehicles');
    }
  }

  useEffect(() => {
    fetchEvList();
  }, []);

  return (
    <>
      {isError ? (
        <ErrorPage statusCode="500" />
      ) : (
        <>
          {loading ? (
            <TableSkelton />
          ) : (
            <Box sx={{ width: '100%', px: 3, pt: 3, '& .MuiDataGrid-root': { border: 'none' } }}>
              <DataGrid
                rows={electricVehicles}
                columns={columns}
                autoHeight
                disableColumnMenu
                checkboxSelection
                onRowSelectionModelChange={(newSelectionModel) => {
                  setSelectionModel(newSelectionModel);
                  const selectedIDs = new Set(newSelectionModel);
                  const selectedRowData = electricVehicles.filter((row: any) =>
                    selectedIDs.has(row.id)
                  );
                  if (newSelectionModel.length === electricVehicles.length) {
                    toggleAll(true);
                  } else if (newSelectionModel.length === 0) {
                    toggleAll(false);
                  } else {
                    const rowChanges = difference(selectedRowData, selectedRow).concat(
                      difference(selectedRow, selectedRowData)
                    );
                    rowChanges.forEach((row: any) => {
                      toggleEv(row.id);
                    });
                  }
                  setSelectedRow(selectedRowData);
                }}
                rowSelectionModel={selectionModel}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 15
                    }
                  }
                }}
                pageSizeOptions={[15]}
                disableRowSelectionOnClick
                sx={{
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'background.paper',
                    borderBottom: 1,
                    borderColor: 'divider',
                  },
                  '& .MuiDataGrid-cell': {
                    borderBottom: 1,
                    borderColor: 'divider',
                  },
                  '& .MuiDataGrid-row:hover': {
                    backgroundColor: 'action.hover',
                  },
                }}
                slots={{
                  noRowsOverlay: () => (
                    <Stack
                      height="100%"
                      alignItems="center"
                      justifyContent="center">
                      <span>No Electric Vehicles exist.</span>
                    </Stack>
                  ),
                }}
              />
            </Box>
          )}
        </>
      )}
    </>
  );
}

export default ComparisonElectricVehicleTabScreen;
